"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import Button from "../components/Button";
import Spinner from "../components/Spinner";
import { Mail } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const router = useRouter();

  const handleForgotPassword = async () => {
    // e.preventDefault();

    if (!email) {
      setError("Email je povinný.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch("/api/auth/reset-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      await response.json();

      if (!response.ok) {
        throw new Error("Nepodarilo sa odoslať email");
      }

      setSuccess(true);
    } catch (error) {
      console.error("Forgot password error:", error);
      setError("Nepodarilo sa odoslať email pre obnovenie hesla.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "40px",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            maxWidth: "500px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <Mail size={48} color="#578319FF" />
          <h2 style={{ color: "#333", marginBottom: "20px" }}>
            Email bol odoslaný
          </h2>
          <p style={{ color: "#666", marginBottom: "30px", lineHeight: "1.6" }}>
            Ak existuje účet s emailom <strong>{email}</strong>, odoslali sme
            vám link na obnovenie hesla. Skontrolujte si email a kliknite na
            odkaz na obnovenie hesla.
          </p>
          <p style={{ color: "#666", fontSize: "14px", marginBottom: "30px" }}>
            Link na obnovenie hesla vyprší za 1 hodinu.
          </p>
          <Button
            variant="primary"
            onClick={() => router.push("/login")}
            style={{ margin: "0 auto" }}
          >
            Späť na prihlásenie
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{ width: "100%", minHeight: "100vh", backgroundColor: "#fff" }}
      className="shadow-border"
    >
      <div className="container">
        <div
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            backgroundImage: 'url("/images/login-bg.jpeg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.3,
            zIndex: 0,
            pointerEvents: "none",
          }}
          aria-hidden="true"
        />

        {/* On the photograph, top left. It used to sit in a white band above
            it, which cost 100px of the image for no reason. */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/ordinex-logo.png"
          alt="Ordinex"
          style={{
            position: "absolute",
            top: 24,
            left: 24,
            width: 200,
            zIndex: 2,
          }}
        />
        <div
          style={{
            width: 500,
            padding: 20,
            position: "relative",
            zIndex: 1,
          }}
          className="shadow-border card"
        >
          <h2 style={{ textAlign: "center" }}>Zabudnuté heslo</h2>
          <p
            style={{
              textAlign: "center",
              color: "#666",
              marginTop: 10,
              marginBottom: "30px",
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            Zadajte váš email a pošleme vám link na obnovenie hesla.
          </p>

          {error && (
            <div
              style={{
                backgroundColor: "#FEF2F2",
                border: "1px solid #FECACA",
                borderRadius: "0.375rem",
                padding: "0.75rem",
                marginBottom: "1rem",
              }}
            >
              <div style={{ color: "#B91C1C", fontSize: "0.875rem" }}>
                {error}
              </div>
            </div>
          )}

          {/* <form onSubmit={handleForgotPassword}> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              marginBottom: 30,
            }}
          >
            <label htmlFor="email" style={{ fontSize: 14 }}>
              Email *
            </label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              id="email"
              name="email"
              placeholder="Zadajte váš email"
              style={{ backgroundColor: "#F3F4F6FF" }}
              disabled={loading}
              required
            />
          </div>

          {/* <div
            style={{
              textAlign: "center",
              marginBottom: 20,
              fontSize: 13,
            }}
          >
            Nemáte účet?{" "}
            <a href="/register" style={{ color: "#0099E0FF" }}>
              Zaregistrovať sa
            </a>
          </div> */}

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Button variant="secondary" onClick={() => router.push("/login")}>
              Zrušiť
            </Button>
            <Button
              onClick={handleForgotPassword}
              variant="primary"
              disabled={loading || !email}
            >
              Odoslať
            </Button>
          </div>
          {/* </form> */}

          {/* <div style={{ textAlign: "center", marginTop: 30 }}>
            <a
              href="/login"
              style={{
                color: "#0099E0FF",
                textDecoration: "none",
                fontSize: "14px",
              }}
            >
              ← Späť na prihlásenie
            </a>
          </div> */}
        </div>
      </div>

      {loading && <Spinner />}

      <style>{`
        .container {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        @media (min-width: 1024px) {
          .container {
            padding-left: 450px;
          }
        }
      `}</style>
    </div>
  );
}
